import { commonConstants } from '../_constants';
import { initialState } from '../_helpers';

export function ticketCategory(state=initialState.ticketCategory, action) {
    switch (action.type) {
        case commonConstants.GET_TICKET_CATEGORY:
            return Object.assign({}, state, action.ticketCategory);
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/ticketCategory.reducer.js